// extracted by mini-css-extract-plugin
export default {"mainFieldContainer":"ContentsFiltersCriteria_mainFieldContainer__48K3G"};